import React from 'react';

const MerceArrivoSection = () => (
  <div className="p-5 space-y-4">
    <p className="text-slate-400 lg:text-gray-600">
      Registra le forniture in ingresso con data, fornitore, temperatura alla consegna e note.
    </p>
    <div className="bg-gradient-to-r from-blue-600/20 to-blue-600/20 lg:from-blue-50 lg:to-blue-50 rounded-xl p-5 border border-blue-500/30 lg:border-blue-100">
      <p className="text-blue-400 lg:text-blue-900 font-semibold mb-3">Funzionalità in arrivo:</p>
      <ul className="space-y-2 text-blue-300 lg:text-blue-700 text-sm">
        <li className="flex items-center gap-2">
          <div className="w-1.5 h-1.5 bg-blue-500 lg:bg-blue-500 rounded-full"></div>
          Registrazione automatica da DDT
        </li>
        <li className="flex items-center gap-2">
          <div className="w-1.5 h-1.5 bg-blue-500 lg:bg-blue-500 rounded-full"></div>
          Controllo temperatura con alert
        </li>
        <li className="flex items-center gap-2">
          <div className="w-1.5 h-1.5 bg-blue-500 lg:bg-blue-500 rounded-full"></div>
          Storico forniture per fornitore
        </li>
      </ul>
    </div>
  </div>
);

export default MerceArrivoSection;
